export const SunriseCircle = ({ size = 24, className = "", strokeWidth = 1.4 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    className={className}
    aria-hidden="true"
  >
    <path
      d="M12 1.8c.42 5.6 3.2 8.38 8.8 8.8-5.6.42-8.38 3.2-8.8 8.8-.42-5.6-3.2-8.38-8.8-8.8 5.6-.42 8.38-3.2 8.8-8.8Z"
      fill="currentColor"
    />
  </svg>
);
